import { IPromise } from 'angular';
import { WORDLIST } from '../../tn.common';
import DjangoClient from '../../tn.django/django-client.service/djangoClient';

export class pangramService {
    static $inject = ['djangoClient'];
    constructor(protected djangoClient: DjangoClient) {}
    generateRandom(): string {
        // Create a random sentence for the custom text options
        const randomWords: string[] = [];
        for (let i = 0; i <= 6; i++) {
            randomWords.push(
                WORDLIST[Math.floor(Math.random() * (WORDLIST.length - 1) + 1)]
            );
        }
        randomWords[0] =
            randomWords[0][0].toUpperCase() + randomWords[0].slice(1);
        return randomWords.join(' ');
    }

    protected transformPangrams(pangrams: { pangram: string}[]): string[] {
        return pangrams.map((p) => p.pangram).concat(this.generateRandom());
    }

    list(): IPromise<string[]> {
        return this.djangoClient.get<{ pangram: string}[]>('/api/1/pangrams/').then((r) => this.transformPangrams(r));
    }
}
